'use client';
import './AverageConsumptionSegmented.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
export default function AverageConsumptionSegmented({ items, activeIndex, onClick }) {
  const handleClick = (value) => {
    onClick?.(value);
  };

  return (
    <div className={'AverageConsumptionSegmented'}>
      <div className={'toggle'}>
        <div className={'inner'}>
          {items.map((item) => (
            <div
              key={item.index}
              role="presentation"
              className={'item'}
              onClick={() => handleClick(item.index)}
              style={{ color: item.index === activeIndex ? '#121212' : '#828282' }}
            >
              <RichText field={item?.fields?.title} />
            </div>
          ))}
          <div
            className={'item_slicer'}
            style={{
              transform: `translateX(${activeIndex * 100}%)`,
              width: `${100 / items.length}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
